import { PATHS } from 'AppConstants';
import { ASSET_PATH } from 'assetsPath';

export const landingImgPath = ASSET_PATH.V2_IMAGES + 'landing/';
export const mobileLandingImgPath = ASSET_PATH.V2_IMAGES + 'landing/mobile/';

export const FooterLinks = [{
	head: 'Business Cities',
	trackVal: 'business_cities_clicked',
	icon: 'icBizCities',
	list: [{
		text: 'Mumbai',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/mumbai-hotels.html`
	},
	{
		text: 'Bangalore',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/bengaluru-hotels.html`
	},
	{
		text: 'Chennai',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/chennai-hotels.html`
	},
	{
		text: 'Pune',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/pune-hotels.html`
	},
	{
		text: 'Hyderabad',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/hyderabad-hotels.html`
	},
	{
		text: 'Kolkata',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/kolkata-hotels.html`
	},
	{
		text: 'Lucknow',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/lucknow-hotels.html`
	},
	{
		text: 'Jaipur',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/jaipur-hotels.html`
	},
	{
		text: 'Surat',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/surat-hotels.html`
	},
	{
		text: 'Bhopal',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/bhopal-hotels.html`
	},
	{
		text: 'Goa',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/goa-hotels.html`
	},
	{
		text: 'Noida',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/noida-hotels.html`
	},
	{
		text: 'Thane',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/thane-hotels.html`
	},
	{
		text: 'Varanasi',
		url: `${PATHS.MYBIZ_API_URL}/corporate-hotels/varanasi-hotels.html`
	}

	]
},
{
	head: 'Blog',
	trackVal: 'blog_clicked',
	icon: 'icBlog',
	list: [{
		text: 'myBiz Reviews',
		url: 'https://www.makemytrip.com/blog/business-travel-mybiz-testimonials'
	},
	{
		text: 'GST on Business Travel',
		url: 'https://www.makemytrip.com/blog/gst-on-business-travel'
	},
	{
		text: 'Save on Business Travel',
		url: 'https://www.makemytrip.com/blog/ways-to-save-on-business-travel'
	},
	{
		text: 'Corporate Travel Platform',
		url: 'https://www.makemytrip.com/blog/things-to-consider-planning-corporate-travel'
	},
	{
		text: 'Things to do on Business Trip',
		url: 'https://www.makemytrip.com/blog/things-to-do-on-business-trips'
	},
	{
		text: 'Why myBiz ?',
		url: 'https://www.makemytrip.com/blog/business-travel-mybiz'
	},
	{
		text: 'Why myBiz Assured ?',
		url: 'https://www.makemytrip.com/blog/mybiz-assured-hotels-for-business-travel'
	},
	{
		text: 'Why MSME\'s need myBiz ?',
		url: 'https://www.makemytrip.com/blog/why-your-msme-needs-mybiz'
	},
	{
		text: 'Business Travel Planning',
		url: 'https://www.makemytrip.com/blog/business-travel-planning'
	},
	{
		text: 'Technology Revolutionizing Business Travel',
		url: 'https://www.makemytrip.com/blog/technology-revolutionizing-business-travel'
	},
	{
		text: 'Best Business Hotels in Bangalore',
		url: 'https://www.makemytrip.com/blog/top-5-business-hotels-in-bangalore'
	},
	{
		text: 'Best Business Hotels in Delhi',
		url: 'https://www.makemytrip.com/blog/business-hotels-in-delhi'
	},
	{
		text: 'Best Business Hotels in Mumbai',
		url: 'https://www.makemytrip.com/blog/best-business-hotels-near-mumbai-airport'
	},
	{
		text: 'India\'s Best Business Hotels',
		url: 'https://www.makemytrip.com/blog/best-luxury-business-hotels-in-india'
	},
	{
		text: 'Best Business Hotels in Chandigarh',
		url: 'https://www.makemytrip.com/blog/business-hotels-in-chandigarh'
	}
	]
},
{
	head: 'Download',
	trackVal: 'Download_clicked',
	icon: 'icDownload',
	list: [{
		alt: 'IOS',
		img: landingImgPath + 'applelink.png',
		mobileImg: mobileLandingImgPath + 'applelink.png',
		url: 'https://applinks.makemytrip.com/joinMyBiz'
	},
	{
		alt: 'Android',
		img: landingImgPath + 'androidlink.png',
		mobileImg: mobileLandingImgPath + 'androidlink.png',
		url: 'https://applinks.makemytrip.com/joinMyBiz'
	}
	]
},
{
	trackVal: 'Quicklinks_clicked',
	head: 'Quick Links',
	icon: 'icQuickLinks',
	list: [
		{
			text: 'myBiz Customer care',
			url: `${PATHS.MYBIZ_API_URL}/corporate/mybiz-customer-care.html`
		},
		{
			text: 'Corporate Travel',
			url: `${PATHS.MYBIZ_API_URL}/corporate/corporate-travel-management.html`
		},
		{
			text: 'Business Hotels',
			url: `${PATHS.MYBIZ_API_URL}/corporate/corporate-hotels-booking.html`
		},
		{
			text: 'Corporate Flights',
			url: `${PATHS.MYBIZ_API_URL}/corporate/corporate-flight-booking.html`
		},
		{
			text: 'Corporate Hotels ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/corporate-hotel-booking.html`
		},
		{
			text: 'Business Travel for MSME ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/business-travel-with-udyam-ngo.html`
		},
		{
			text: 'GST Invoice for International flights ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/gst-invoice-international-flights.html`
		},
		{
			text: 'Business Travel Solutions ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/business-travel-solutions.html`
		},
		{
			text: 'GST Invoice for Bus',
			url: `${PATHS.MYBIZ_API_URL}/corporate/gst-for-bus-travel.html`
		},
		{
			text: 'Corporate Bus booking ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/corporate-bus-booking.html`
		},
		{
			text: 'myBiz - Best Business Travel Platform ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/best-business-travel-platform.html`
		},
		{
			text: 'GST Invoice for Flights ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/gst-invoice-flights.html`
		},
		{
			text: 'GST Invoice for Travel ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/gst-bill.html`
		},
		{
			text: 'GST Invoice for Hotels ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/hotels-gst-invoice.html`
		},
		{
			text: 'myBiz for Small Business ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/travel-for-small-business.html`
		},
		{
			text: 'Free cancellation on International Flights ',
			url: `${PATHS.MYBIZ_API_URL}/corporate/corporate-flights-free-cancellation-international.html`
		}
	]
},
{
	trackVal: 'follow_us_clicked',
	head: 'Follow us',
	icon: 'icFollowUs',
	list: [{
		text: 'Twitter',
		url: 'https://twitter.com/makemytrip'
	},
	{
		text: 'Facebook',
		url: 'https://www.facebook.com/makemytrip/'
	},
	{
		text: 'Linkedin',
		url: 'https://www.linkedin.com/showcase/makemytrip-for-business'
	}
	]
},
{
	trackVal: 'others_clicked',
	head: 'Others',
	icon: 'icLegals',
	list: [{
		text: 'About us',
		url: 'https://www.makemytrip.com/about-us/company_profile.php'
	},
	{
		text: 'Privacy Policy',
		url: 'https://www.makemytrip.com/legal/privacy_policy.html'
	},
	{
		text: 'User Agreement',
		url: 'https://www.makemytrip.com/legal/user_agreement.html'
	},
	{
		text: 'Terms of Services',
		url: 'https://www.makemytrip.com/legal/user_agreement.html#tos'
	},
	{
		text: 'Mail us',
		url: 'mailto:myBizAcquisition@gommt.onmicrosoft.com?subject=myBiz Query'
	}
	]
}
];
